// Caminhos simples
export const STYLEGUIDE = '/styleguide';
export const HOME = '/home';
export const OUTRAS_INFOS = '/outrasInformacoes';
export const MEUS_DADOS = '/meus-dados';
export const PLANO_B = '/plano-b';
export const REQUERIMENTOS = '/requerimentos/*';
export const PERSONALIZACAO = '/personalizacao/*';
export const SIMULAR_USUARIO = '/simularUsuario/:matricula/:token';
export const SIMULAR_USUARIO_PORTAL = '/simularUsuario';
export const PARCELA_ADICIONAL = '/parcela-adicional';
export const SIMULACAO_TRANSFORMACAO_PLA = '/simulacaoTransformacaoPLA';
export const FORM_TRANSFORMACAO_PLA = '/solicitacaoTransformacaoPLA';
export const FORM_TRANSFORMACAO_PLA_SUCCESS = '/successTransformacaoPLA';
export const EXTRATO_APOSENTADORIA = '/extratoContaAposentadoria';
export const EXTRADO_SALDO_CONTAS = '/extratoSaldoContas';
export const EXTRADO_SALDO_CONTAS_ASSISTIDO_PENSIONISTA =
  '/extratoSaldoContasPensionistaAssistido';
export const CONTRACHEQUE = '/contracheque';
export const INFORME_RENDIMENTOS = '/informeRendimentos';
export const ABONO_ANUAL = '/abonoAnual';
export const MEMORIA_CALCULO = '/memoriaCalculoBeneficio';
export const EMPRESTIMO_CONSCIENTE = '/saibaMaisEmprestimoConsciente';
export const CALENDARIO_EMPRESTIMO = '/calendario-emprestimo';
export const EMISSAO_BOLETO_VOLUNTARIO = '/emissaoBoletoVoluntario';
export const REGULAMENTO_EMPRESTIMO = '/regulamentoEmprestimo';
export const REGRAS_GERAIS_EMPRESTIMO = '/regrasGeraisEmprestimo';
export const TIRA_DUVIDAS = '/tireSuasDuvidasEmprestimo';
export const CONTATO_EMPRESTIMO = '/fale-conosco';
export const EXTRATO_PARTICIPANTE = '/extrato-participante';
export const VALOR_BENEFICIO = '/valor-beneficio';
export const TRANSPARENCIA = '/transparencia';
export const LOGIN = '/login';
export const RECUPERAR_SENHA = '/recuperar-senha';
export const PRIMEIRO_ACESSO = '/primeiro-acesso';
export const SAQUE_VISTA = '/saqueAVista';
export const TRANSFORMACAO_BENEFICIO = '/transformacaoBeneficio';
export const RESERVA_MATEMATICA = '/reservaMatematica';
export const COMUNICACAO_PLANO = '/comunicacaoPlano';
export const CUSTEIO_ADMINISTRATIVO = '/custeioAdministrativo';
export const OPCAO_INSTITUTO = '/obterOpcaoInstituto';
export const HISTORICO_TROCA_RECEBIMENTO_RENDA =
  '/historicoTrocaRecebimentoRenda';
export const SEGUNDA_VIA_BOLETO = '/segundaViaBoleto';
export const IMPOSTO_DE_RENDA = '/imposto-de-renda';
export const CALCULADORA_EXAURIMENTO = '/calculadora-exaurimento';
export const SAIBA_MAIS_SAUDE_FINANCEIRA = '/saiba-mais-saude-financeira';
// Caminhos compostos
// ------------------------------------------------------------------

export const PERFIL_INVESTIMENTO = '/perfilInvestimento';

export const TROCA_DE_PERFIL = 'trocaPerfil';
export const QUESTIONARIO = 'questionario';
export const INTENCAO_MUDANCA_PERFIL = 'intencaoMudancaPerfil';
export const MUDANCA_PERFIL = 'mudancaPerfil';

export const TROCA_DE_PERFIL_ABSOLUTE_PATH = `${PERFIL_INVESTIMENTO}/${TROCA_DE_PERFIL}`;
export const QUESTIONARIO_ABSOLUTE_PATH = `${PERFIL_INVESTIMENTO}/${QUESTIONARIO}`;
export const INTENCAO_MUDANCA_PERFIL_ABSOLUTE_PATH = `${PERFIL_INVESTIMENTO}/${INTENCAO_MUDANCA_PERFIL}`;
export const MUDANCA_PERFIL_ABSOLUTE_PATH = `${PERFIL_INVESTIMENTO}/${MUDANCA_PERFIL}`;

// ------------------------------------------------------------------
export const PERCENTUAL_RENDA_INICIAL = '/percentualRecebimento';

export const PERCENTUAL_RENDA_MENSAL = 'percentualRecebimentoRendaMensal';
export const HISTORICO_RENDA_MENSAL =
  'historicoPercentualRecebimentoRendaMensal';

export const PERCENTUAL_RENDA_MENSAL_ABSOLUTE_PATH = `${PERCENTUAL_RENDA_INICIAL}/${PERCENTUAL_RENDA_MENSAL}`;
export const HISTORICO_RENDA_MENSAL_ABSOLUTE_PATH = `${PERCENTUAL_RENDA_INICIAL}/${HISTORICO_RENDA_MENSAL}`;

// ------------------------------------------------------------------

export const TABELA_CONTRIBUICAO = '/tabelaContribuicao';
export const PERCENTUAL_CONTRIBUICAO = '/percentualContribuicao';

export const ALTERAR_PC = 'alterarPercentualContribuicao';
export const INTENCAO_MUDANCA_PC = 'intencaoMudancaPercentualContribuicao';
export const MUDANCA_PC = 'mudancaPercentualContribuicao';

export const ALTERAR_PC_ABSOLUTE_PATH = `${PERCENTUAL_CONTRIBUICAO}/${ALTERAR_PC}`;
export const INTENCAO_MUDANCA_PC_ABSOLUTE_PATH = `${PERCENTUAL_CONTRIBUICAO}/${INTENCAO_MUDANCA_PC}`;
export const MUDANCA_PC_ABSOLUTE_PATH = `${PERCENTUAL_CONTRIBUICAO}/${MUDANCA_PC}`;

// ------------------------------------------------------------------

export const EMPRESTIMOS = '/emprestimos';

export const SIMULADOR = 'simulador';

export const SOLICITACAO = 'solicitacao';
export const CONFIRMACAO = 'confirmacao';

export const CONTRATOS = 'contratos';

export const SIMULADOR_ABSOLUTE_PATH = `${EMPRESTIMOS}/${SIMULADOR}`;
export const SOLICITACAO_ABSOLUTE_PATH = `${EMPRESTIMOS}/${SIMULADOR}/${SOLICITACAO}`;
export const CONFIRMACAO_ABSOLUTE_PATH = `${EMPRESTIMOS}/${SIMULADOR}/${CONFIRMACAO}`;

export const CONTRATOS_ABSOLUTE_PATH = `${EMPRESTIMOS}/${CONTRATOS}`;

// ------------------------------------------------------------------

export const BENEFICIOS = '/beneficios';

export const RESULTADO_BENEFICIOS = 'resultado';
export const BENEFICIARIOS = 'beneficiarios';

export const RESULTADO_BENEFICIOS_ABSOLUTE_PATH = `${BENEFICIOS}/${RESULTADO_BENEFICIOS}`;
export const BENEFICIARIOS_ABSOLUTE_PATH = `${BENEFICIOS}/${BENEFICIARIOS}`;

// ------------------------------------------------------------------

export const CONVERSAO_BENEFICIOS = '/conversaoBeneficios';

export const BENEFICIARIOS_CONVERSAO = 'beneficiariosConversao';
export const RESULTADO_CONVERSAO = 'resultadoConversao';

export const SIMULADOR_RESGATE_PARCIAL = '/simuladorResgateParcial';
export const SOLICITACAO_RESGATE_PARCIAL = '/solicitacaoResgateParcial';
export const SOLICITACAO_RESGATE_PARCIAL_HISTORICO = `${SOLICITACAO_RESGATE_PARCIAL}/historico`;
export const SOLICITACAO_RESGATE_PARCIAL_FORMULARIO = `${SOLICITACAO_RESGATE_PARCIAL}/formulario`;
export const SOLICITACAO_RESGATE_PARCIAL_INFORME = `${SOLICITACAO_RESGATE_PARCIAL}/informe`;

export const BENEFICIARIOS_CONVERSAO_ABSOLUTE_PATH = `${CONVERSAO_BENEFICIOS}/${BENEFICIARIOS_CONVERSAO}`;
export const RESULTADO_CONVERSAO_ABSOLUTE_PATH = `${CONVERSAO_BENEFICIOS}/${RESULTADO_CONVERSAO}`;

export const SOLICITACAO_SUCESSO = '/solicitacaoSucesso';

export const PARCELA_ADICIONAL_HISTORICO = `${PARCELA_ADICIONAL}/historico`;
export const PARCELA_ADICIONAL_FORMULARIO = `${PARCELA_ADICIONAL}/formulario`;
